/*
 * Traducciones catalan
 */
import messages from './ca.json';

// Añadimos aquí traducciones de validación que necesitan ser una function para vee-validate
// No pueden estar incluidas en el json de traducciones
messages.validation = {
  contains_lowercase: messages.password.error.passwordLowerCaseError,
  contains_number: messages.password.error.passwordNumberError,
  contains_special_character: messages.password.error.passwordSpecialCharacterError,
  contains_uppercase: messages.password.error.passwordUpperCaseError,
  length: (field, args) => {
    const min = args[0];
    const max = args[1];
    return max ? `El nombre mínim d'elements del camp ${field} ha d'estar entre ${min} i ${max}.` : `El nombre mínim d'elements del camp ${field} ha de ser ${min}.`;
  },
  max_same_consecutive_chars: (field, args) => {
    const maxNumber = args[0] - 1;
    return messages.password.error.passwordMaxConsecutiveCharactersError.replace('{number}', maxNumber);
  },
  new_password: messages.password.error.passwordMatchesOldOneError,
};

export default messages;
